<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Магазин</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "Shop",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      let shopId = props.data?.shop_id

      if (shopId === undefined) {
        throw new Error("Не указан shop_id")
      }

      if (shopId === null) {
        return "Не выбран"
      }

      let shops = getShops()

      if (shops === undefined) {
        throw new Error("Не указан shops")
      }

      let shop = detect(shopId, shops)

      if (shop === null) {
        return "Не определен"
      }

      return shop.title
    }

    function detect(shopId, shops) {
      let items = shops.filter((item) => {
        return parseInt(item["id"]) === shopId
      })

      if (items.length === 0) {
        return null
      }

      return {
        title: items[0].title,
      }
    }

    function getShops() {
      return props.data?.shops
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
